import type { FormControlSetting } from '@/app/editor/iframe/atom/Atom.model';

import { GpThirdParty } from '@/app/editor/iframe/atom/third-party/GpThirdParty';

const FormControlSettings: Array<FormControlSetting> = [
  {
    type: 'html:attr',
    name: 'widget',
    refreshType: 'all',
    property: 'data-widget',
    targetSelector: '.module',
    options: [
      {
        key: 'reviews',
        value: 'Reviews',
      },
      {
        key: 'badge',
        value: 'Star Badge',
      },
      {
        key: 'carousel',
        value: 'Carousel',
      },
      {
        key: 'fullPage',
        value: 'Full Page',
      },
      {
        key: 'visualGallery',
        value: 'Visual Gallery',
      },
      {
        key: 'wallPhotos',
        value: 'Wall Photos',
      },
      {
        key: 'topRated',
        value: 'Top Rated',
      },
      {
        key: 'sideDrawer',
        value: 'Side Drawer',
      },
      {
        key: 'sideBadge',
        value: 'Site Badge',
      },
      {
        key: 'instagramFeed',
        value: 'Instagram Feed',
      },
      {
        key: 'checkoutComments',
        value: 'Checkout Comments',
      },
    ],
    default_value: 'reviews',
  },
  {
    type: 'custom:align',
    name: 'alignment',
    targetSelector: '.module',
    property: '',
  },
  {
    type: 'html:extraClass',
    name: 'extra_class',
    targetSelector: '.module',
    property: 'data-exc',
    default_value: '',
  },
];

/**
 * Hero Banner Atom Module
 */
export class GpStampedReview extends GpThirdParty {
  public $el: JQuery;

  /**
   * override getLabel từ Atom
   * @returns Name
   */
  getLabel(): string {
    return this.$el.attr('data-label') || 'Stamped.io Product Reviews';
  }

  /**
   * override getLabel từ Atom
   * @returns Slug
   */
  getSlug(): string {
    return this.$el.attr('data-slug') || 'stamped-product-reviews';
  }

  /**
   * getFormControlSettings;
   * @returns setting read/write from left-sidebar to live page
   */
  getFormControlSettings(): Array<FormControlSetting> {
    return FormControlSettings;
  }

  /**
   * check
   * @returns true: change setting after drag
   */
  isAutoRenderSetting() {
    return true;
  }
}
